import { getImg } from '@/utils/matchAsset'

export const matchRewardCashPrizeData = {
  titleImage: getImg('match/pc/match/reward-cash-title.png'),
  prizeImage: getImg('match/pc/match/reward-cash-prize-values.png'),
  centeredDescription: [
    '赛季专属服 100%收益计入赛事奖金池',
    '千年争霸赛总体奖金池公布： 9月15日-10月31日0点  奖金池总流水金额：135222.00，（需扣除 充值退款,充值通道费，所得税）最终实发金额已商务传达为准。每一个阶段会重置个人限购药品购买次数，药品规则：16强 商城重置个人限购药品包一次，8强  商城重置个人限购药品包一次，4强开始 清空背包所有药品（每轮商城免费购买一次药品包）',
    '收益来源：药品（白酒+小丸丹）+无属性时装+千年传音等不影响数值平衡类道具',
  ],
  prizeDescription: [
    '冠军（第 1 名）：10 万 RMB 元固定奖金 + 奖金池 70%收益+冠军奖杯+25周年纪念币',
    '亚军（第 2 名）：2 万 RMB 元固定奖金 + 奖金池 20%收益+亚军奖杯+25周年纪念币',
    '季军（第 3 名）：1 万 RMB 元固定奖金 + 奖金池 10%收益+季军奖杯+25周年纪念币',
    '（上述为税前金额，根据相关所得税法律，官方将代缴20%税务）'
  ],
}

export const matchRewardIndividualPrizeData = {
  titleImage: getImg('match/pc/match/reward-individual-title.png'),
  prizeImage: getImg('match/pc/match/reward-individual-prize.png'),
  characterImage: getImg('match/pc/match/reward-character.png'),
  leftDecorationImage: getImg('match/pc/match/reward-left-decoration.png'),
  commandAwardLabelImage: getImg('match/pc/match/reward-command-award-label.png'),
  killAwardLabelImage: getImg('match/pc/match/reward-kill-award-label.png'),
  evaluationText: '评选依据：战队总积分、临场调度、全程零违规，官方统一评分评选',
  commandAwards: [
    { rank: '第一名', reward: '1万RMB+25周年纪念币' },
    { rank: '第二名', reward: '5000RMB+25周年纪念币' },
    { rank: '第三名', reward: '2000RMB+25周年纪念币' },
  ],
  killAward: '共1名奖励：5000 元现金 + 25周年纪念币',
  killRule: '评选标准：门派战开启后游戏击杀页面会实时刷新门派战中击杀数据,官方将统计每一场击杀数排名，海选赛至总决赛全部场次比赛合计击杀总数量最高的玩家获得本奖项。',
  killAwards: '注:每场比赛单角色封顶20击杀数,若最终击杀人数相同将按照游戏内门派战击杀排名榜数据为最终依据。'
}
